function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.722 13.575a3.738 3.738 0 0 0 3.542-3.911 3.68 3.68 0 0 0-3.542-3.806 3.7 3.7 0 0 0-3.551 3.824 3.734 3.734 0 0 0 3.551 3.893zm-5.485 8.174h10.951c1.45 0 1.951-.439 1.951-1.248 0-2.259-2.865-5.37-7.427-5.37S3.286 18.242 3.286 20.5c0 .81.501 1.249 1.951 1.249z",
  transform: "translate(-3.286 -5.859)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.14 13.408a.8.8 0 0 0 .58-.246l2.294-2.3 2.311 2.3a.769.769 0 0 0 .58.246.8.8 0 0 0 .8-.809.773.773 0 0 0-.246-.562l-2.3-2.312 2.312-2.32a.736.736 0 0 0 .246-.554.8.8 0 0 0-.809-.8.745.745 0 0 0-.562.237l-2.329 2.32L18.7 6.3a.73.73 0 0 0-.562-.229.784.784 0 0 0-.8.791.745.745 0 0 0 .237.554l2.312 2.312-2.312 2.32a.745.745 0 0 0-.237.554.8.8 0 0 0 .802.806z",
  transform: "rotate(45 22.835 4.334)"
}));

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.949,
    height: 15.891,
    viewBox: "0 0 22.949 15.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.0678e5b5.svg";
export { ForwardRef as ReactComponent };